// @flow

// import { HitchpinCardTypeNames } from '../../components/Shared/HitchpinCard/HitchpinCardTypeNames';
import { GTMTrackedEvents, TrackedItems } from './TrackingEnums';
import { findTopmostParentCategory } from '../categoryHelper';
import {
  doesHaveDelivery,
  extractPrice,
  getPricingDetailsArray,
} from '../pricingHelper';
import type { ListingDetailContextType } from './TrackingContext';
const TrackedListingActions = Object.freeze({
  Offering: 'offering',
  Wanted: 'wanted',
  Storefront: 'storefront',
});

type TrackedListingDictionaryType = {
  [listingAction: string]: (context: ListingDetailContextType) => any,
};

const ListingDetailActionDictionary: TrackedListingDictionaryType = {
  [TrackedListingActions.Offering]: (context: ListingDetailContextType) => {
    const offering = context.offering;
    const category = context.category;
    if (!offering || !category) return {};
    const categories = context.categories;
    const pricingArray = getPricingDetailsArray(offering, category, 'price');
    const offeringPrice = extractPrice(pricingArray[0]?.detail);
    const availabilityArray = getPricingDetailsArray(
      offering,
      category,
      'availability',
    );
    // regular expression to extract the number at the beginning of the pricing structure
    const availabilityDetail = availabilityArray[0]?.detail;
    const availability = availabilityDetail
      ? parseFloat(availabilityDetail.match(/^\d+(\.\d+)?/))
      : null;
    const parentCategory = findTopmostParentCategory(category?.id, categories);
    const eventProperties = {
      dataLayer: {
        event: GTMTrackedEvents.GTMPageVisited,
        id: offering.id,
        type: TrackedItems.Seller,
        title: offering.title,
        price: offeringPrice,
        quantity: availability,
        city: offering.city,
        state: offering.state,
        category: category?.name,
        top_level_category: parentCategory?.name,
        delivery: doesHaveDelivery(offering),
      },
    };
    return eventProperties;
  },
  [TrackedListingActions.Wanted]: (context: ListingDetailContextType) => {
    const wanted = context.wanted;
    const category = context.category;
    if (!wanted || !category) return {};
    const parentCategory = findTopmostParentCategory(
      category.id,
      context.categories,
    );
    const eventProperties = {
      dataLayer: {
        event: GTMTrackedEvents.GTMPageVisited,
        id: wanted.id,
        type: TrackedItems.Buyer,
        title: wanted.title,
        price: false,
        quantity: false,
        city: wanted.city,
        state: wanted.state,
        category: category?.name,
        top_level_category: parentCategory?.name,
        delivery: false,
      },
    };
    return eventProperties;
  },
  [TrackedListingActions.Storefront]: (context: ListingDetailContextType) => {
    const storefront = context.storefront;
    if (!storefront) return {};
    const eventProperties = {
      dataLayer: {
        event: GTMTrackedEvents.GTMPageVisited,
        id: storefront.id,
        type: TrackedItems.StoreFront,
        title: storefront.name,
        city: storefront.city,
        state: storefront.state,
      },
    };
    return eventProperties;
  },
};
export { TrackedListingActions, ListingDetailActionDictionary };
